import { cn } from '@/utils'
import { TextInput } from './inputs'
import type { FieldsetProps } from './types'

export function TextFieldset({
  operator,
  value,
  setValue,
  value2,
  setValue2,
  handleKeyDown,
}: FieldsetProps) {
  return (
    <div className={cn('grid gap-2', operator === 'between' && 'grid-cols-2')}>
      <div className="grid gap-2">
        <TextInput
          label="Value"
          value={value}
          onChange={setValue}
          onKeyDown={handleKeyDown}
        />
      </div>

      {operator === 'between' && (
        <div className="grid gap-2">
          <TextInput
            label="Second Value"
            value={value2}
            onChange={setValue2}
            onKeyDown={handleKeyDown}
          />
        </div>
      )}
    </div>
  )
}
